import React from 'react';

export type BadgeVariant = 'demo' | 'info' | 'warning' | 'neutral';

interface BadgeProps {
  variant?: BadgeVariant;
  className?: string;
  title?: string;
  children: React.ReactNode;
}

const variantClass: Record<BadgeVariant, string> = {
  demo: 'ui-badge ui-badge--demo',
  info: 'ui-badge ui-badge--info',
  warning: 'ui-badge ui-badge--warning',
  neutral: 'ui-badge bg-gray-100 text-content-secondary',
};

export const Badge: React.FC<BadgeProps> = ({
  variant = 'neutral',
  className = '',
  title,
  children,
}) => (
  <span className={`${variantClass[variant]} ${className}`.trim()} title={title}>
    {children}
  </span>
);

export default Badge;
